module.exports = __webpack_public_path__ + "static/media/upgrade-hero-banner-mob.9be3b53e.png";